import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ParkbewilligungenData, PbActions } from '../parkbewilligungen-data';
import moment from 'moment';
/**
 * Generated class for the PbperiodenCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbperioden-create',
  templateUrl: 'pbperioden-create.html',
})
export class PbperiodenCreatePage {
  period = {};
  maxDate;
  constructor(public navCtrl: NavController
    , public navParams: NavParams
    , public pbData: ParkbewilligungenData    
    , private _viewController: ViewController
    ) {
      this.maxDate = moment.utc().add(2, 'y').format('YYYY-MM-DD');
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad PbperiodenCreatePage');
  }

  confirmPeriod(){
    this.pbData.createnewperiod = this.period;
    this._viewController.dismiss(true);
  }

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbperioden-create/pbperioden-create.ts